import { Theme } from '@mui/material/styles';
import get from 'lodash/get';

export const fromThemeOrDefault = (
  theme: any,
  prop?: string | number | null
): any => prop && get(theme, prop, prop);

export const getThemeColor = (theme: Theme, path?: string | number): any =>
  fromThemeOrDefault(theme.palette, path);
